module.exports = __webpack_public_path__ + "videos/color-drop_jp.72ca30d.mp4";